import React from "react"

import { render } from "~utils/rehype-render"
import * as style from "./Parameter.module.scss"

const Description = ({ param }) => (
  <div className={style.description}>{render(param.descriptionAst)}</div>
)

export default Description
